import Vue from 'vue'
import Router from 'vue-router'
import Projects from './views/Projects.vue'
import Photography from './views/Photography.vue'
import Contact from './views/Contact.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/projects'

    },
    {
      path: '/projects',
      name: 'projects',
      component: Projects,
    },
    {
      path: '/photography',
      name: 'photography',
      component: Photography,
    },
    {
      path: '/contact',
      name: 'contact',
      component: Contact
    }
  ]
})

